/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseregistrationEnrollmentCourseregistrationidMonographTab200,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidMonographTab400,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidMonographTab401,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidMonographTab500,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidMonographTabPathParams,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidMonographTabQueryResponse,
} from "../../types/courseRegistrationEnrollmentController/GetApiV1CourseregistrationEnrollmentCourseregistrationidMonographTab.ts";
import { courseRegistrationManagementMonographViewModelSchema } from "../courseRegistrationManagementMonographViewModelSchema.ts";

export const getApiV1CourseregistrationEnrollmentCourseregistrationidMonographTabPathParamsSchema =
  z.object({
    courseRegistrationId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidMonographTabPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidMonographTab200Schema =
  z.lazy(
    () => courseRegistrationManagementMonographViewModelSchema,
  ) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidMonographTab200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidMonographTab400Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidMonographTab400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidMonographTab401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidMonographTab401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidMonographTab500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidMonographTab500>;

export const getApiV1CourseregistrationEnrollmentCourseregistrationidMonographTabQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1CourseregistrationEnrollmentCourseregistrationidMonographTab200Schema,
  ) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidMonographTabQueryResponse>;
